// extracted by mini-css-extract-plugin
module.exports = {"header":"infoRoute_header__33VWc","logo":"infoRoute_logo__3GBVz","description":"infoRoute_description__2aVA5"};